import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51c5036c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup-overlay" }
const _hoisted_2 = { class: "popup" }
const _hoisted_3 = ["innerHTML"]





export default /*#__PURE__*/_defineComponent({
  __name: 'YesNoPopup',
  props: {
  message: {
    type: String,
    default: '',
  },
  cancelTxt: {
    type: String,
    default: 'Cancel',
  },
  confirmTxt: {
    type: String,
    default: 'Confirm',
  },
},
  emits: ["confirmed", "cancelled"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit

function confirmed() {
  // 処理の確認
  console.log('confirm')
  emit('confirmed')

}
function cancelled() {
  console.log('cancel')
  emit('cancelled')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        innerHTML: props.message
      }, null, 8, _hoisted_3),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "cancel",
          onClick: cancelled
        }, _toDisplayString(props.cancelTxt), 1),
        _createElementVNode("button", {
          class: "confirm",
          onClick: confirmed
        }, _toDisplayString(props.confirmTxt), 1)
      ])
    ])
  ]))
}
}

})